import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Clock, MapPin, Phone, Mail, ChefHat, Waves, Star } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
const Index = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const heroImages = ["./images/Restaurant .jpeg", "./images/exterieur .jpeg", "./images/interieur .jpeg"];
  const specialties = [{
    name: "Choucroute de la mer",
    description: "Moules, Filet de Loup, Saumon, St Pierre",
    price: "À partir de 28,90€",
    image: "./images/choucroute .jpeg"
  }, {
    name: "Moules",
    description: "Marinière, Crème, Roquefort",
    price: "À partir de 16€",
    image: "./images/moule .jpeg"
  }];
  const openingHours = [{
    day: "Lundi",
    hours: "Fermé"
  }, {
    day: "Mardi",
    hours: "11h30-14h30"
  }, {
    day: "Mercredi",
    hours: "11h30-14h30 • 19h-21h30"
  }, {
    day: "Jeudi",
    hours: "11h30-14h30 • 19h-21h30"
  }, {
    day: "Vendredi",
    hours: "11h30-14h30 • 19h-21h30"
  }, {
    day: "Samedi",
    hours: "11h30-14h30 • 19h-21h30"
  }, {
    day: "Dimanche",
    hours: "11h30-14h30"
  }];
  return <div className="min-h-screen bg-background">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm z-50 shadow-wave">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <img src="./images/Logo restaurant .jpeg" alt="Logo La Baleine Bleue" className="h-12 w-12 object-contain" />
              <h1 className="text-2xl font-bold text-primary">La Baleine Bleue</h1>
            </div>
            <div className="flex space-x-3 md:space-x-6 text-sm md:text-base">
              <a href="#accueil" className="text-foreground hover:text-primary transition-smooth">Accueil</a>
              <Link to="/menu" className="text-foreground hover:text-primary transition-smooth">Menu</Link>
              <Link to="/about" className="text-foreground hover:text-primary transition-smooth">À propos</Link>
              <Link to="/contact" className="text-foreground hover:text-primary transition-smooth">Contact</Link>
            </div>
            <Link to="/contact">
              <Button className="ocean-gradient text-white shadow-ocean hover:shadow-wave transition-wave">
                Réserver
              </Button>
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="accueil" className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img src={heroImages[currentImageIndex]} alt="Restaurant La Baleine Bleue" className="w-full h-full object-cover transition-all duration-1000" />
          <div className="absolute inset-0 bg-gradient-to-r from-primary/80 via-primary/60 to-transparent"></div>
        </div>
        
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <div className="animate-wave mb-6">
            <img src="./images/Logo restaurant .jpeg" alt="Logo La Baleine Bleue" className="h-16 w-16 mx-auto mb-4 object-contain" />
          </div>
          <h1 className="text-5xl md:text-7xl font-bold mb-6 drop-shadow-lg">
            La Baleine Bleue
          </h1>
          <p className="text-xl md:text-2xl mb-4 drop-shadow-md">
            Restaurant La Baleine Bleue à Saint Pierre La Mer
          </p>
          <p className="text-lg mb-8 opacity-90">
            Chef Philippe Lung vous propose sa fameuse Choucroute de la Mer et les cordons bleus
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/menu">
              <Button size="lg" className="bg-white text-primary hover:bg-white/90 shadow-elegant transition-wave">
                <ChefHat className="mr-2 h-5 w-5" />
                Découvrir nos spécialités
              </Button>
            </Link>
            <Link to="/contact">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-primary transition-wave">
                <Phone className="mr-2 h-5 w-5" />
                Réserver une table
              </Button>
            </Link>
          </div>
        </div>

        {/* Image navigation dots */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {heroImages.map((_, index) => <button key={index} onClick={() => setCurrentImageIndex(index)} className={`w-3 h-3 rounded-full transition-all ${index === currentImageIndex ? 'bg-white' : 'bg-white/50'}`} />)}
        </div>
      </section>

      {/* Chef Section */}
      <section className="py-20 wave-gradient">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Badge className="mb-6 ocean-gradient text-white border-0">
              <ChefHat className="mr-2 h-4 w-4" />
              Notre Chef
            </Badge>
            <h2 className="text-4xl font-bold mb-6 text-foreground">
              Philippe Lung
            </h2>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Spécialiste de la choucroute de la mer et cordon bleu, le Chef Philippe Lung a créé sa fameuse 
              <strong className="text-primary">Choucroute de la Mer</strong>, un plat signature unique 
              alliant tradition et innovation. Passionné par les produits frais de nos côtes méditerranéennes, 
              il vous propose une cuisine authentique où chaque ingrédient est sublimé.
            </p>
            <div className="flex justify-center space-x-1">
              {[...Array(5)].map((_, i) => <Star key={i} className="h-6 w-6 fill-yellow-400 text-yellow-400" />)}
            </div>
          </div>
        </div>
      </section>

      {/* Specialties Section */}
      <section id="specialites" className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <Badge className="mb-6 ocean-gradient text-white border-0">
              <Waves className="mr-2 h-4 w-4" />
              Nos Spécialités
            </Badge>
            <h2 className="text-4xl font-bold mb-6 text-foreground">
              Les Trésors de la Mer
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Découvrez nos spécialités : choucroute de la mer et cordon bleu
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {specialties.map((specialty, index) => <Card key={index} className="group hover:shadow-ocean transition-wave border-0 shadow-elegant overflow-hidden">
                <div className="relative h-48 overflow-hidden">
                  <img src={specialty.image} alt={specialty.name} className="w-full h-full object-cover group-hover:scale-110 transition-wave" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-wave"></div>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold mb-2 text-foreground">{specialty.name}</h3>
                  <p className="text-muted-foreground mb-4 text-sm leading-relaxed">{specialty.description}</p>
                  <div className="flex justify-between items-center">
                    <span className="text-2xl font-bold text-primary">{specialty.price}</span>
                    <Link to="/contact">
                      <Button size="sm" className="ocean-gradient text-white shadow-wave hover:shadow-ocean transition-wave">
                        Commander
                      </Button>
                    </Link>
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Menu Preview */}
      <section id="menu" className="py-20 wave-gradient">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <Badge className="mb-6 ocean-gradient text-white border-0">
              Menu Complet
            </Badge>
            <h2 className="text-4xl font-bold mb-6 text-foreground">
              Notre Carte
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-8">
              Explorez notre sélection complète de plats préparés avec passion
            </p>
            <Link to="/menu">
              <Button size="lg" className="ocean-gradient text-white shadow-ocean hover:shadow-wave transition-wave">
                Voir le menu complet
              </Button>
            </Link>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
            <img src="./images/Carte 1 .jpeg" alt="Menu 1" className="rounded-lg shadow-elegant hover:shadow-ocean transition-wave" />
            <img src="./images/Carte 2 .jpeg" alt="Menu 2" className="rounded-lg shadow-elegant hover:shadow-ocean transition-wave" />
            <img src="./images/Carte 3.jpeg" alt="Menu 3" className="rounded-lg shadow-elegant hover:shadow-ocean transition-wave" />
            <img src="./images/Carte 4 Midi .jpeg" alt="Menu 4" className="rounded-lg shadow-elegant hover:shadow-ocean transition-wave" />
          </div>
        </div>
      </section>

      {/* Contact & Hours */}
      <section id="contact" className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <Badge className="mb-6 ocean-gradient text-white border-0">
                <MapPin className="mr-2 h-4 w-4" />
                Contact
              </Badge>
              <h2 className="text-4xl font-bold mb-8 text-foreground">
                Nous Trouver
              </h2>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <MapPin className="h-6 w-6 text-primary mt-1" />
                  <div>
                    <h3 className="font-semibold text-foreground mb-1">Adresse</h3>
                    <p className="text-muted-foreground">
                      3 place du port<br />
                      11560 Saint Pierre La Mer
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <Phone className="h-6 w-6 text-primary mt-1" />
                  <div>
                    <h3 className="font-semibold text-foreground mb-1">Téléphone</h3>
                    <p className="text-muted-foreground">
                      <a href="tel:0434442464" className="hover:text-primary transition-smooth">
                        04 34 44 24 64
                      </a>
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  
                  <div>
                    
                    <p className="text-muted-foreground"></p>
                  </div>
                </div>
              </div>
            </div>

            {/* Opening Hours */}
            <div>
              <Badge className="mb-6 ocean-gradient text-white border-0">
                <Clock className="mr-2 h-4 w-4" />
                Horaires
              </Badge>
              <h2 className="text-4xl font-bold mb-8 text-foreground">
                Nos Horaires
              </h2>
              
              <Card className="shadow-elegant border-0">
                <CardContent className="p-6">
                  <div className="space-y-4">
                    {openingHours.map((schedule, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-border last:border-0">
                        <span className="font-medium text-foreground">{schedule.day}</span>
                        <span className={`text-sm ${schedule.hours === "Fermé" ? "text-destructive" : "text-muted-foreground"}`}>
                          {schedule.hours}
                        </span>
                      </div>)}
                  </div>
                  
                  <div className="mt-6 p-4 bg-secondary rounded-lg">
                    <p className="text-sm text-muted-foreground text-center">
                      <strong>Fermé :</strong> Dimanche soir, Lundi toute la journée, Mardi soir
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-primary text-white py-12">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <h3 className="text-2xl font-bold">La Baleine Bleue</h3>
            </div>
            <p className="text-white/80 mb-6">
              Restaurant La Baleine Bleue • Chef Philippe Lung • Saint Pierre La Mer
            </p>
            <div className="flex justify-center space-x-6">
              <a href="#" className="text-white/80 hover:text-white transition-smooth">Facebook</a>
              
              <a href="#" className="text-white/80 hover:text-white transition-smooth">TripAdvisor</a>
            </div>
            <div className="mt-8 pt-8 border-t border-white/20">
              <p className="text-white/60 text-sm">
                © 2024 La Baleine Bleue. Tous droits réservés.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>;
};
export default Index;